import React, { useState } from 'react';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/pro-light-svg-icons';
import { RESOURCE_TYPES } from '../helpers/resourceTypes';

export const GenerateResourceButton = ({ id, activeTab }) => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = !!anchorEl;

  const activeResource = RESOURCE_TYPES.find((type) => type.id === activeTab);

  if (activeResource) {
    return (
      <Button
        variant="contained"
        className="mss__button primary"
        id={`${id}__button_generate_${activeResource.id}`}
        onClick={() => navigate(activeResource.route)}
      >
        Generate {activeResource.label}
      </Button>
    );
  }

  return (
    <Box className="generateResource" id={`${id}__generateResource`}>
      <Button
        variant="contained"
        className="mss__button primary"
        id={`${id}__button_generateResource`}
        aria-expanded={isOpen}
        aria-haspopup="menu"
        onClick={(e) => setAnchorEl(e.currentTarget)}
        endIcon={<FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />}
      >
        Generate a Resource
      </Button>

      <Menu
        id={`${id}__menu_generateResource`}
        anchorEl={anchorEl}
        open={isOpen}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        className="mss__generateResourceMenu"
        slotProps={{
          paper: { className: 'generateResourceOptions' },
          list: { 'aria-labelledby': `${id}__button_generateResource` },
        }}
      >
        {RESOURCE_TYPES.map(({ id: typeId, label, route }) => (
          <MenuItem
            key={typeId}
            className="generateResourceOption"
            id={`${id}__button_generate_${typeId}`}
            onClick={() => {
              setAnchorEl(null);
              navigate(route);
            }}
          >
            <Typography className="optionLabel">{label}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};
